import getConfig from 'next/config';

import mapDataSearchGroup from '../../helpers/mapDataSearchGroup';
import dataSearch from '../data-search';
import termsApi from '../terms';

/**
 * @param searchId
 * @param options
 * @returns {EventDataFetcher}
 */
const fetchEvents = async (searchId, options) => {
  const { publicRuntimeConfig } = getConfig();
  const dataSearchPromise = dataSearch.get(searchId, {
    language: options?.language,
    type: 'EVENTS',
    query: options?.query,
    groups: options?.groups?.map((group) => ({
      categoryIds: group.categoryIds,
      includeCounts: group.withCounts,
      includeItems: group.withItems,
    })),
  });
  const termsPromise = termsApi.get(
    options?.language ?? publicRuntimeConfig.defaultLanguage,
  );

  const dataSearchResponse = await dataSearchPromise;
  if (
    dataSearchResponse.status !== 'OK' ||
    dataSearchResponse.data.type !== 'EVENTS'
  ) {
    throw Error('Got unexpected response');
  }

  const termsResponse = await termsPromise;
  if (termsResponse.status !== 'OK') {
    throw Error('Got unexpected response');
  }

  const { data: terms } = termsResponse;
  const { data: result } = dataSearchResponse;

  /**
   * @param {DataSearchGroupApiProps} group
   * @returns {DataSearchGroup}
   */
  const groupMapper = (group) => mapDataSearchGroup(group, terms);

  return {
    groups: result.groups.map(groupMapper),
    items: result.items,
  };
};

export default fetchEvents;
